import { useParams } from "react-router";

import { VatCodeEditForm } from "src/app/features/VatCode/components/forms/VatCodeEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { HistoryButton } from "../../../../components/FeatureButtons/HistoryButton";
import { OkButton } from "../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../components/Form/hooks/useFormSubmitTrigger";
import { getAssignedDataGroup } from "../../../../core/router/auth";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";

export const VatCodeEditFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk } = useFormSubmitTrigger();
    const hasWriteAccess = canAccess(ResourceName.VAT_CODES, "basicTabsWrite");
    const { id } = useParams();
    const dataGroup = getAssignedDataGroup();
    const historyUrl = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.VAT_CODES}/${id}/${FORM_ACTION.HISTORY}`;

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.VatCodeEditFormPage" />
                <ActionBar>
                    <OkButton isDisabled={!hasWriteAccess} onClick={triggerOk} />
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerSubmit} />
                    <HistoryButton url={historyUrl} />
                    <CancelButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.VAT_CODES}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <VatCodeEditForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
